(function ($) {
	$(document).ready(function () {
		let pagetop = '#pagetop';
		let footer = 'footer';

		$(pagetop).hide();
		$(footer).css('position', 'relative');

		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 500) {
				$(pagetop).slideDown("fast");
			} else {
				$(pagetop).slideUp("fast");
			}
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $(footer).innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$(pagetop).css({//フッターに到達したら
					"position": "absolute",
					"bottom": footHeight - 24
				});
			} else { //フッターに到達する前
				$(pagetop).css({
					"position": "fixed",
					"bottom": "20px"
				});
			}
		});
		$(pagetop).on('click', function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
	});

	// // #で始まるアンカーをクリックした場合にスクロール処理
	// $('a[href^="#"]:not(a.notscroll)').on('click',function(){
	// 	console.log('click');
	// 	let speed = 500;
	// 	let href = $(this).attr("href");
	// 	let target = $(href == "#" || href == "" ? 'html' : href);
	// 	target = target.offset().top;
	// 	let headerHeight = $("#masthead").innerHeight();
	// 	console.log(headerHeight);
	// 	let position = target - headerHeight - 100;
	// 	$("html, body").animate({ scrollTop: position }, speed, "swing");
	// 	return false;
	// });




	// #で始まるアンカーをクリックした場合にスクロール処理
	// if (window.matchMedia("(min-width: 767px)").matches) {
	// 	jQuery('a[href^="#"]').click(function () {
	// 		let speed = 181;
	// 		let href = jQuery(this).attr("href");
	// 		let target = jQuery(href == "#" || href == "" ? 'html' : href);
	// 		target = target.offset().top;
	// 		let headerHeight = 181;
	// 		let position = target - headerHeight;
	// 		jQuery("html, body").animate({ scrollTop: position }, speed, "swing");
	// 		return false;
	// 	});
	// } else {
	// 	jQuery('a[href^="#"]').click(function () {
	// 		let speed = 500;
	// 		let href = jQuery(this).attr("href");
	// 		let target = jQuery(href == "#" || href == "" ? 'html' : href);
	// 		target = target.offset().top;
	// 		let headerHeight = 90;
	// 		let position = target - headerHeight;
	// 		jQuery("html, body").animate({ scrollTop: position }, speed, "swing");
	// 		return false;
	// 	});
	// }
	/*
	jQuery(function () {
		var windowWidth = $(window).width();
		var headerHight = 1000;
		jQuery('a[href^="#"]').click(function () {
			var speed = 1000;
			var href = jQuery(this).attr("href");
			var target = jQuery(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - headerHight;
			jQuery('body,html').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	});
	*/

	// MW wp FOEMのスクロール位置調整
	document.addEventListener("load", function () {
		var posy = $('.mw_wp_form').offset().top;
		posy = posy + parseInt(mwform_scroll.offset);
		if ($(window).width() > 767) {
			posy = posy - 300;
		} else {
			posy = posy - 300;
		}
		$(window).scrollTop(posy);
	});
})(jQuery);


// #で始まるアンカーをクリックした場合にスクロール処理
(function ($) {
	let headerHeight = $('#masthead').innerHeight(); //ヘッダーの高さ取得
	let urlHash = location.hash; // ハッシュ取得
	console.log('ヘッダーの高さ' + headerHeight);
	console.log(urlHash);
	if(urlHash) { // ページ外からのページ内スクロールの場合
			$('body,html').stop().scrollTop(0);
			setTimeout(function(){
					let target = $(urlHash);
					let position = target.offset().top - headerHeight
					$('body,html').stop().animate({scrollTop:position}, 500);
			}, 100);
	}
	$('a[href^="#"]:not(a.notscroll)').on('click',function() {
			let href= $(this).attr("href");
			let target = $(href);
			let position = target.offset().top - headerHeight;
			$('body,html').stop().animate({scrollTop:position}, 500);
	});
})(jQuery);